import axios from "axios";

export const listHelpers = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Helper/helpers`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
